import {NgModule} from '@angular/core';
import {ContentDirective} from "./content.directive";

@NgModule({
    declarations: [
        ContentDirective,
    ],
    exports: [
        ContentDirective,
    ],
})
export class ContentModule {}
